import { render, staticRenderFns } from "./zhnyDetails.vue?vue&type=template&id=455e7e1b"
import script from "./zhnyDetails.vue?vue&type=script&lang=js"
export * from "./zhnyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports